export default __webpack_public_path__ + "static/media/heightArrow.be554d8e.svg";